import {INIT_MEMBER_DETAILS, SET_MEMBER_DATA, SET_MEMBER_KEY, SET_SHOW_PASSWORD, SET_UPDATE_MEMBER_ERROR,
    SET_ADDRESS_VALIDATION_ERROR_NO_ACTION, SET_MEMBER_ACTION, SET_LAT_LNG} from "../../actions/actionTypes";

export function memberReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case INIT_MEMBER_DETAILS:
            if (window.Farmigo) {
                return Object.assign({}, state, window.Farmigo.memberDetails);
            }
            return state;
        case SET_MEMBER_DATA:
            return Object.assign({}, state, action.memberDetails);
        case SET_MEMBER_KEY:
            return Object.assign({}, state, {
                key: action.memberKey
            });
        case SET_MEMBER_ACTION:
            return Object.assign({}, state, {
                memberAction: action.memberAction
            });
        case SET_SHOW_PASSWORD:
            return Object.assign({}, state, {showPassword: action.showPassword});
        case SET_UPDATE_MEMBER_ERROR:
            return Object.assign({}, state, {
                updateMemberError: action.error
            });
        case SET_LAT_LNG:
            return Object.assign({}, state, {
                lat: action.lat,
                lng: action.lng
            });
        case SET_ADDRESS_VALIDATION_ERROR_NO_ACTION:
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/login/memberReducer.js